module.exports = __webpack_public_path__ + "images/Incorrect_default.svg";